import UserFormLayout, { transformValues } from './form'
import GenericEditForm from '../common/edit'

export default () => <GenericEditForm formLayoutComponent={<UserFormLayout />} transformValues={transformValues} />
